import Vue from "vue"
import App from "@hub/landing-page/src/App.vue"
import router from "@hub/landing-page/src/router"
import i18n from "@shared/plugins/i18n.plugin"

import "@shared/styles/main.scss"
import "@shared/plugins/fontAwesome.plugin"

import { toastProgrammatic } from "@shared/components/src/ui-components/VToast"

import ColorsConfig from "@shared/plugins/colors.plugin"

Vue.prototype.$toast = toastProgrammatic

if (process.env.VUE_APP_ENV === "production") {
  window.dataLayer = window.dataLayer || []

  function gtag() {
    dataLayer.push(arguments)
  }

  gtag("js", new Date())

  gtag("config", "G-1YHRD419EY") //tag para Site
}

const colorsConfig = new ColorsConfig()
Vue.prototype.$colors = colorsConfig

const app = new Vue({
  router,
  i18n,
  render: h => h(App)
})

app.$mount("#app")

window.$vue = app
